const state = {
  MAXCOUNT_DIALOGAPK: 5,
  tooltipAttributes: {
    value: false,
    disabled: false,
    content: ''
  },
  miniDialogAPK: []
}

const mutations = {
  SET_MINIDIALOGAPK: (state, obj) => {
    state.miniDialogAPK.push(obj)
  },
  CLEAR_MINIDIALOGAPK: (state, index) => {
    // 销毁页面上的组件, 主要是超出限制时, 需销毁临界删除的组件
    state.miniDialogAPK[index].instance.isShowDialog = false

    state.miniDialogAPK.splice(index, 1)
  },
  SET_TOOLTIPATTRIBUTES: (state, attr) => {
    state.tooltipAttributes = attr
  }
}

const actions = {
  // 存在的不进行添加
  addMiniDialogAPK({ commit }, obj) {
    const index = state.miniDialogAPK.findIndex(item => item.instance._uid === obj.instance._uid)
    if (index === -1) {
      // 限制任务最大数, 到达临界时删除第一个
      if (state.miniDialogAPK.length >= state.MAXCOUNT_DIALOGAPK) {
        commit('CLEAR_MINIDIALOGAPK', 0)
      }
      commit('SET_MINIDIALOGAPK', obj)
    }
  },
  // 存在才进行删除
  clearMiniDialogAPK({ commit }, uid) {
    const index = state.miniDialogAPK.findIndex(item => item.instance._uid === uid)
    if (index > -1) {
      commit('CLEAR_MINIDIALOGAPK', index)
    }
  },
  // 设置是否显示RightSDKWinTask.vue 的tooltip
  setTooltipAttributes({ commit, state }, attr) {
    commit('SET_TOOLTIPATTRIBUTES', Object.assign(state.tooltipAttributes, attr))
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
